import React from 'react';

import { Button, ButtonProps } from '@/src/components/common/Elements/Button/Button';

interface ApiButtonProps extends Omit<ButtonProps, 'onClick'> {
  id: string;
  onClick?: () => void;
}

const ApiButton = ({ id, ...otherProps }: ApiButtonProps) => {
  return (
    <Button
      id={id}
      className={`apiButton`}
      buttonClassSettings={{ variant: 'style_unset' }}
      tooltip={{ place: 'left', effect: 'solid', content: 'Quickbooks Online' }}
      onClick={() => {}}
      {...otherProps}
    >
      <span
        className={`tw-relative tw-bg-no-repeat tw-bg-center tw-bg-contain tw-inline-block tw-min-h-[24px] tw-w-[24px] tw-p-0`}
        style={{ backgroundImage: `url(/images/quickbooks-icon1.png)` }}
      />
    </Button>
  );
};

export default ApiButton;
